export const blogSortOptions = [
    { label: "Сначала новое", value: "desc" },
    { label: "Сначала старое", value: "asc" }
];